module.exports = __webpack_public_path__ + "static/media/map.7b373ec1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/map.svg
// module id = 2254
// module chunks = 0